import React from 'react';
import { isEmpty } from '@/utils/common-helpers';

type Props = {
    desc?: any;
    pageTitle: string;
    bg: string;
    ndaText?: string;
    discussingRequirementText?: string;
    designingText?: string;
    developmentText?: string;
    deploymentText?: string;
};

const HireProcessPythonDevelop: React.FC<Props> = ({
    pageTitle,
    desc,
    bg,
    ndaText,
    designingText,
    developmentText,
    deploymentText,
    discussingRequirementText,
}) => {
    return (
        <section className={`section-py ${bg}`}>
            <div className="text-white container lg:container mx-auto">
                <div className="row grid md:grid-cols-12 !gap-y-0">
                    <div className="md:col-span-8 md:col-start-3 mb-5 md:mb-[70px] lg:mb-0">
                        <div className="flex flex-col gap-2.5 text-center">
                            <h2 className="text-white">{pageTitle}</h2>
                            <p className="text-grey mb-0 fw-600">{desc}</p>
                        </div>
                    </div>
                    <div className="md:col-span-12 xl:col-span-12 xxl:col-span10 text-center about-us-animation">
                        <div className="process-list process-list-python">
                            <div className="process-item process-item-white text-center">
                                <div className="process-icon process-icon-white mx-auto mb-4 grid rounded-full">
                                    <svg>
                                        <use xlinkHref="#ic-requirement-analysis" />
                                    </svg>
                                </div>
                                <p className="text-white fw-500 px-2.5 mb-[15px] custom-min-height">
                                    Requirement<br></br> Analysis
                                </p>
                                <p className="text-grey fs-md fw-400 mb-0 px-3 minheight-cardinner-pag">
                                    {isEmpty(ndaText)
                                        ? 'We start by understanding your business objectives, technical challenges, and project scope to ensure a solid foundation.'
                                        : ndaText}
                                </p>
                            </div>
                            <div className="circle circle-white circle-reverse" />
                            <div className="process-item  process-item-white process-item-reverse text-center">
                                <div className="process-icon process-icon-white process-icon-reverse mx-auto mb-4 grid rounded-full">
                                    <svg>
                                        <use xlinkHref="#ic-planning-strategy" />
                                    </svg>
                                </div>
                                <p className="text-white fw-500 px-2.5 mb-[15px] custom-min-height">Planning & Strategy</p>
                                <p className="text-grey fs-md fw-400 mb-0 px-3 minheight-cardinner-pag">
                                    {isEmpty(discussingRequirementText)
                                        ? 'A well-structured roadmap is created, outlining timelines, technologies, and resources needed for seamless execution.'
                                        : discussingRequirementText}
                                </p>
                            </div>
                            <div className="circle circle-white circle-2" />
                            <div className="process-item process-item-white text-center">
                                <div className="process-icon process-icon-white mx-auto mb-4 grid rounded-full">
                                    <svg>
                                        <use xlinkHref="#ic-designing" />
                                    </svg>
                                </div>
                                <p className="text-white fw-500 px-2.5 mb-[15px] custom-min-height">UI/UX Design</p>
                                <p className="text-grey fs-md fw-400 mb-0 px-3 minheight-cardinner-pag">
                                    {isEmpty(designingText)
                                        ? 'Our design experts craft intuitive, user-friendly, and visually compelling interfaces that enhance user engagement.'
                                        : designingText}
                                </p>
                            </div>
                            <div className="circle circle-white circle-reverse circle-3" />
                            <div className="process-item process-item-white process-item-reverse text-center">
                                <div className="process-icon process-icon-white mx-auto mb-4 grid rounded-full">
                                    <svg>
                                        <use xlinkHref="#ic-development" />
                                    </svg>
                                </div>
                                <p className="text-white fw-500 px-2.5 mb-[15px] custom-min-height">Development & Testing</p>
                                <p className="text-grey fs-md fw-400 mb-0 px-3 minheight-cardinner-pag">
                                    {isEmpty(developmentText)
                                        ? 'Using agile methodologies, we build robust solutions with continuous testing to ensure performance, security, and scalability.'
                                        : developmentText}
                                </p>
                            </div>
                            <div className="circle circle-white circle-4" />
                            <div className="process-item process-item-white text-center">
                                <div className="process-icon process-icon-white mx-auto mb-4 grid rounded-full">
                                    <svg>
                                        <use xlinkHref="#ic-support" />
                                    </svg>
                                </div>
                                <p className="text-white fw-500 px-2.5 mb-[15px] custom-min-height">Deployment & Support</p>
                                <p className="text-grey fs-md fw-400 mb-0 px-3 minheight-cardinner-pag">
                                    {isEmpty(deploymentText)
                                        ? 'We handle smooth deployment, monitor performance, and provide ongoing maintenance for long-term success.'
                                        : deploymentText}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HireProcessPythonDevelop;
